import { BasePayloadMapper } from '@ps/utils';

import { GetSurveysDto } from '../dtos/survey.dto';
import { HttpParams } from '@angular/common/http';

export class GetSurveyPayloadMapper extends BasePayloadMapper<
  GetSurveysDto,
  HttpParams
> {
  public toPayload(dto: GetSurveysDto): HttpParams {
    const payloadObj: Record<string, string> = {};
    Object.entries(dto).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        payloadObj[key] = value;
      }
    });

    return new HttpParams({ fromObject: payloadObj });
  }
}
